module.exports = __webpack_public_path__ + "static/analytics-0c8f5fa082a38bc2e6e11d27506de607.png";